import React from 'react';

interface NumberInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
}

const NumberInput: React.FC<NumberInputProps> = ({ label, name, value, onChange, placeholder, required = false }) => (
  <div className="mb-4">
    <label htmlFor={name} className="block text-primary-dark font-medium mb-2">{label}</label>
    <input
      id={name}
      name={name}
      type="number"
      value={value}
      onChange={onChange}
      required={required}
      placeholder={placeholder}
      className="w-full bg-primary-light/10 border-none rounded-2xl px-5 py-3 focus:outline-none focus:ring-2 focus:ring-primary-light transition text-primary-dark shadow-md hover:bg-primary-light/20"
    />
  </div>
);

export default NumberInput;
